module.exports = "<p>\n  site-modal works!\n</p>\n"